import { Badge } from "@mantine/core";

interface OutcomeBadgeProps {
  // Structural — both DomainSentenceEntry and WalletSentenceEntry satisfy this.
  readonly entry: {
    readonly gatesPass: boolean;
    readonly rewardRank: number | null;
  };
}

export function OutcomeBadge({ entry }: OutcomeBadgeProps) {
  if (!entry.gatesPass) {
    return (
      <Badge color="red" variant="light">
        Gate fail
      </Badge>
    );
  }
  if (entry.rewardRank === 1) {
    return (
      <Badge color="green" variant="light">
        Win
      </Badge>
    );
  }
  return (
    <Badge color="gray" variant="light">
      Rank {entry.rewardRank ?? "—"}
    </Badge>
  );
}
